<template>
<v-card>
    <v-card-title class="headline">Attribute Value</v-card-title>
    <v-card-text>
        <v-form ref="editForm" v-model="formValid">
            <v-layout class="dialog-content">
                <v-flex xs12>
                    <v-layout wrap>
                        <v-flex xs12 v-if="!editData.UserDefinedValue">
                            <v-text-field box clearable label="Name" v-model="editData.Name" :rules="[
                                    rules.required, 
                                    rules.maxOneHundredCharacters
                                ]" counter>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 v-else>
                            <v-autocomplete                                
                                label="User Defined Type"
                                :items="availableTypes"
                                item-value="Value"
                                item-text="Text"
                                v-model="editData.UserDefinedType"
                                box                                                                 
                                clearable
                                placeholder="Type"
                                :rules="[
                                    rules.requiredObject                                    
                                ]"
                                >
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox label="User Defined" v-model="editData.UserDefinedValue">
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox label="Active" v-model="editData.IsActive">
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
        <v-alert 
            :value="submitError != null" 
            outline 
            type="error">
            <span>{{ submitError }}</span>
        </v-alert>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :disabled="!formValid" @click="submit">OK</v-btn>
        <v-btn color="error" @click="cancel">Cancel</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import validationRules from "@/helpers/validationrules";

export default {
    props: {        
        item: {
            required: true,
            type: Object
        },
        submitError: {
            required: false,
            type: String
        },
    },
    data() {
        return {
            rules: validationRules.rules,
            editData: {},
            formValid: false,
            availableTypes: [
            {
                Text: 'Integer',
                Value: 'integer'
            },
            {
                Text: 'Decimal',
                Value: 'decimal'
            },
            {
                Text: 'Date',
                Value: 'date'
            }
            ]
        }
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        submit() {
            if (this.editData.UserDefinedValue) {
                this.editData.Name = "User Defined";
            }
            
            this.$emit("submit", this.editData);
        },
    },
    async created() {
        this.editData = JSON.parse(JSON.stringify(this.item));
    }
}
</script>
